import styled from "styled-components";

const PortfolioContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  * {
    box-sizing: border-box;
  }
`;

const SectionTitle = styled.div`
  width: 40px;
  position: relative;
  background-color: lightpink;
`;

const SectionTitleCopy = styled.span`
  position: absolute;
  font-family: Arial;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: 50% 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  white-space: nowrap;
  color: white;
  font-weight: bold;
`;

const WorkContainer = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: ${({ isFirst }) => isFirst ? "calc(100% - 40px)" : "100%"};
`;

const WorkGallery = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

const WorkGalleryItem = styled.li`
  display: block;
  padding: 0;
  width: 100%;
`;

const WorkGalleryImage = styled.img`
  display: block;
  height: auto;
  width: 100%;
`;

const WorkImage = styled.div`
  display: block;
  padding-top: ${({ heightPercent }) => heightPercent}%;
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center;
  width: 100%;
`;

const WorkItem = styled.div`
  position: relative;
  display: flex;
  width: ${({ width }) => width}px;
  flex-grow: ${({ growthRatio }) => growthRatio};
  flex-basis: ${({ width }) => width}px;
  flex-shrink: ${({ growthRatio }) => growthRatio};

  &:last-child {
    max-width: 600px;
  }
`;

const WorkTitle = styled.h2`
  display: none;
  bottom: 0;
  left: 0;
  position: absolute;
  padding: 0;
  margin: 0;
`;

export {
  PortfolioContainer,
  SectionTitle,
  SectionTitleCopy,
  WorkContainer,
  WorkGallery,
  WorkGalleryItem,
  WorkGalleryImage,
  WorkImage,
  WorkItem,
  WorkTitle
};
